import axios from "axios";

export const SyncFullMexPMOperations = () => {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `mex-preventative-maintenance/sync-full`,  {
      headers,
    });
  };